import api from './api';

export function getDocumentFileApiPath(documentId: number): string {
  return `/documents/${documentId}/file/`;
}

/** Fetch a PDF as an authenticated blob URL (for iframes and downloads). */
export async function fetchDocumentPdfBlobUrl(documentId: number): Promise<string> {
  const response = await api.get(getDocumentFileApiPath(documentId), {
    responseType: 'blob',
  });
  const blob = new Blob([response.data], { type: 'application/pdf' });
  return URL.createObjectURL(blob);
}

/** Open a document PDF in a new tab using authenticated API access. */
export async function openDocumentPdf(documentId: number): Promise<void> {
  const blobUrl = await fetchDocumentPdfBlobUrl(documentId);
  window.open(blobUrl, '_blank');
  window.setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
}

export function revokeDocumentPdfBlobUrl(blobUrl: string | null | undefined): void {
  if (blobUrl) {
    URL.revokeObjectURL(blobUrl);
  }
}
